import React, { useContext, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { emailValidation, phoneValidation } from '../constants/constant';
import { submitContactForm } from '../service/api';
import { useLocation } from 'react-router-dom';
import { myContext } from '../App';

const ContactPopup = ({ closeContactPopup, defaultInquiryTopic, onSuccess }) => {
  //PS_06 -- This is the initial form data
  const initialformdata = {

    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    businessName: "",
    businessURL: "",
    inquiryTopic: "",
    message: "",

  }

  //PS_07 -- This is the initial values for validations
  const initialvalidation = {

    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    businessName: "",
    businessURL: "",
    inquiryTopic: "",
    message: "",

  }

  //PS_08 -- Declared state variables
  const [formData, setformdata] = useState(initialformdata)
  const [formvalidation, setformvalidation] = useState(initialvalidation)
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const { pathname } = useLocation()
  const [isLoading, setIsLoading] = useState(false);
  const [failedAttempts, setFailedAttempts] = useState(0);


  const messageContext = useContext(myContext)

  //PS_09 -- Declared uselocation hook
  const location = useLocation();

  useEffect(() => {
    let val;

    switch (pathname) {
      case "/InventoryFinancing":
        val = "Inventory Financing";
        break;
      case "/BrokerServices":
        val = "Broker Services";
        break;
      default:
        val = "";
        break;
    }

    setformdata((prev) => ({ ...prev, inquiryTopic: val }))

  }, []);

  //PS_11 - PS_13 --  This function captures the values entered in the input field and stores that in the formdata state variable
  function handleOnChange(event) {

    setformdata((prev) => ({ ...prev, [event.target.id]: event.target.value }))
    setSuccessMessage(false);
    setErrorMessage(false);

  }

  //PS_17 - PS_28 -- This function is used to perform Mandatate field abd Regex validations
  function validation() {
    let valid = true;
    let newValidation = { ...initialvalidation };

    if (formData.firstName === "") {
      newValidation.firstName = "Enter the first name";
      valid = false;
    }
    if (formData.lastName === "") {
      newValidation.lastName = "Enter the last name";
      valid = false;
    }
    if (formData.emailAddress === "") {
      newValidation.emailAddress = "Enter the email address";
      valid = false;
    } else if (!emailValidation(formData.emailAddress)) {
      newValidation.emailAddress = "Enter a valid email address";
      valid = false;
    }
    if (formData.phoneNumber === "") {
      newValidation.phoneNumber = "Enter the phone number";
      valid = false;
    } else if (!phoneValidation(formData.phoneNumber)) {
      newValidation.phoneNumber = "Enter your 10-digit phone number without dashes";
      valid = false;
    }
    if (formData.inquiryTopic === "") {
      newValidation.inquiryTopic = "Choose an inquiry topic";
      valid = false;
    }
    setformvalidation(newValidation);
    return valid;
  }

  //PS_15 - PS_36 -- This function is used to handle the submit action of the form
  async function handleSubmit(event) {
    event.preventDefault();

    if (validation()) {

      setIsLoading(true);

      try {
        const payload = {
          ...formData,
          source: "www",
          sourceRef: location.pathname
        };
        const response = await submitContactForm(payload);
        if (response.status === 200) {
          setIsLoading(false);
          setFailedAttempts(0);
          setformdata(initialformdata);
          setSuccessMessage(true);
          messageContext.setIsThankMessage(false);
          onSuccess();
        }
        else {
          setIsLoading(false);
          setFailedAttempts(prev => prev + 1);
          setErrorMessage(true);
        }

      } catch (error) {
        setIsLoading(false);
        setFailedAttempts(prev => prev + 1);
        setErrorMessage(true);
      }
    }
  }

  //PS_38 - PS_39 -- This function is used to close the popup
  function handleClose() {
    closeContactPopup(false);
  }

  function disableFunction() {

    let val

    switch (pathname) {
      case "/InventoryFinancing":
        val = "Inventory Financing";
        break;
      case "/BrokerServices":
        val = "Broker Services";
        break;
      default:
        val = "";
        break;
    }

    if (val) return true

    return false

  }


  return (
    <div
      className="modal fade show"
      id="contactform-modal"
      tabIndex={-1}
      aria-labelledby="contactform-modalLabel"
      aria-modal="true"
      role="dialog"
      style={{ display: 'block', paddingLeft: 0 }}
    >
      <div className="modal-dialog modal-dialog-centered modal-xl">
      <div className="modal-content custom-contact-form">
      
        <div className="modal-header border-0 p-0">
          <button
            type="button"
            className="btn-close"
            onClick={handleClose}
            aria-label="Close"
          >
            <img src="./images/model-close-icon.svg" alt="close-icon" className="popup-close-icon" />
          </button>
        </div>
        <div className="modal-body border-0 p-0 text-center">
          <p className="grey-color-v1 font-34 font-medium cfs-form-title">
            Our team is here to help. Contact us today!
          </p>
          <div className="row model-cfs-form-fields text-start">
            <div className="col-md-6">
              <label htmlFor="firstName">First Name *</label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                maxLength={150}
                placeholder="First Name"
                onChange={(event) => {
                  handleOnChange(event)
                }}
                value={formData.firstName}
              />
              <span style={{ color: 'red', font: '12px' }}>{formvalidation.firstName}</span>
            </div>
            <div className="col-md-6">
              <label htmlFor="lastName">Last Name *</label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                maxLength={150}
                placeholder="Last Name"
                onChange={(event) => {
                  handleOnChange(event)
                }}
                value={formData.lastName}
              />
              <span style={{ color: 'red', font: '12px' }}>{formvalidation.lastName}</span>
            </div>
            <div className="col-md-6">
              <label htmlFor="emailAddress">Email Address *</label>
              <input
                type="email"
                className="form-control"
                id="emailAddress"
                maxLength={150}
                placeholder="Email Address"
                onChange={(event) => {
                  handleOnChange(event)
                }}
                value={formData.emailAddress}
              />
              <span style={{ color: 'red', font: '12px' }}>{formvalidation.emailAddress}</span>
            </div>
            <div className="col-md-6">
              <label htmlFor="phoneNumber">Phone Number *</label>
              <input
                type="tel"
                className="form-control"
                id="phoneNumber"
                maxLength={50}
                placeholder="Phone Number"
                onChange={(event) => {
                  handleOnChange(event)
                }}
                value={formData.phoneNumber}
              />
              <span style={{ color: 'red', font: '12px' }}>{formvalidation.phoneNumber}</span>
            </div>
            <div className="col-md-6">
              <label htmlFor="businessName">Business Name</label>
              <input
                type="text"
                className="form-control"
                id="businessName"
                maxLength={150}
                placeholder="Business Name"
                onChange={(event) => {
                  handleOnChange(event)
                }}
                value={formData.businessName}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="businessURL">Business URL</label>
              <input
                type="text"
                className="form-control"
                id="businessURL"
                maxLength={150}
                placeholder="Business URL"
                onChange={(event) => {
                  handleOnChange(event)
                }}
                value={formData.businessURL}
              />

            </div>
            <div className="col-md-12">
              <label htmlFor="inquiryTopic">Inquiry Topic *</label>
              <select
                className="form-select"
                id="inquiryTopic"
                onChange={(event) => {
                  handleOnChange(event)
                }}
                aria-label="Default select example"
                value={formData.inquiryTopic}
                disabled={disableFunction() ? true : false}
              >
                <option value="">Please select</option>
                <option value={"Equipment Dealer/Manufacturer"}>Equipment Dealer/Manufacturer</option>
                <option value={"Canon Authorized Dealer/Reseller"}>Canon Authorized Dealer/Reseller</option>
                <option value={"Broker Services"}>Broker Services</option>
                <option value={"Inventory Financing"}>Inventory Financing</option>
                <option value={"Customer Service"}>Customer Service</option>
                <option value={"General Inquiry"}>General Inquiry</option>
                <option value={"Careers"}>Careers</option>
              </select>
              <span style={{ color: 'red', font: '12px' }}>{formvalidation.inquiryTopic}</span>
            </div>
            <div className="col-md-12">
              <label htmlFor="message">Message</label>
              <textarea
                className="form-control"
                id="message"
                maxLength={4000}
                placeholder="Message"
                defaultValue={''}
                onChange={(event) => {
                  handleOnChange(event)
                }}
                value={formData.message}
              />
            </div>
            <div class="col-md-12">
              {/* {successMessage && <p className="success-msg">Thank you! Your submission has been received.</p>} */}
              {errorMessage && <p className="error-msg">Submission failed. Please ensure all required fields are filled out correctly and try again.</p>}
            </div>
          </div>
          <div className="form-submit-btn">
            <button 
            className="mt-2 secondary-btn" 
            disabled={isLoading}
            onClick={handleSubmit}
            > {isLoading ? <Spinner animation="border" size="sm" /> : "Submit" } 
            </button>
          </div>
        </div>
        {failedAttempts >= 3 && (
        <div className="alert alert-warning mt-3">
          Having trouble? Contact us at <a href="mailto:contact@cfs.canon.com">contact@cfs.canon.com</a>
        </div>
      )}
        <div className="modal-footer border-0 p-0">
          <button type="button" className="secondary-btn" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>     
    </div>
  );
};

export default ContactPopup;